import { Injectable } from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { ResponseWrapper } from '@library/common/http';

import { CacheService } from '@library/core/services';

import { Template } from './template';

@Injectable({
   providedIn: 'root'
})
export class TemplateService {
   url = 'template';

   constructor( private http: HttpClient, private cache: CacheService ) {}

   getTemplates(): Observable<Template[]> {
      return this.cache.request<ResponseWrapper<Template>, Template[]>({
         url: this.url,
         pipe: pipe(
            map( rw => rw.response.collection ),
         ),
      });
   }

   getTemplate( id: string ): Observable<Template> {
      return this.cache.request<ResponseWrapper<Template>, Template>({
         url: `${this.url}/${id}`,
         pipe: pipe(
            map( rw => rw.response.collection[0] ),
         ),
      });
   }

   saveTemplate( template: Template ): Observable<any> {
      this.cache.clearSet( this.url );

      if ( template.id ) {
         return this.http.patch( this.url, template );
      }

      return this.http.post( this.url, template );
   }

   deleteTemplate( id: number ): Observable<any> {
      this.cache.clearSet( this.url );

      return this.http.delete( `${this.url}/${id}` );
   }

   clearCached( id ) {
      this.cache.clearSet( `${this.url}/${id}` );
   }

   reset() { }
}
